export default __webpack_public_path__ + "bml-characteristic4.21add0e.png";